export default "__VITE_ASSET__1f1a504a__"